import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import {
  RouteParamsTypes, PermissionModulesEnum, PermissionActionsEnum,
  Modules,
  NonAuthRoutes
} from '../enums';
import ProtectedRoute from '../components/ProtectedRoute';
import InvoiceList from '../modules/invoices/addList';
import InvoiceEditPreviewPayment from '../modules/invoices/editPreviewPayment';

const Invoices: React.FC = () => {
  return (
    <Routes>
      <Route path={RouteParamsTypes.blank} element={<ProtectedRoute component={InvoiceList} accessibleTo={[{ [PermissionModulesEnum.Invoices]: [PermissionActionsEnum.View] }]} />} />
      <Route path={RouteParamsTypes.view + RouteParamsTypes.id} element={<ProtectedRoute component={InvoiceEditPreviewPayment} accessibleTo={[{ [PermissionModulesEnum.Invoices]: [PermissionActionsEnum.View] }]} />} />
      <Route path={RouteParamsTypes.edit + RouteParamsTypes.id} element={<ProtectedRoute component={InvoiceEditPreviewPayment} accessibleTo={[{ [PermissionModulesEnum.Invoices]: [PermissionActionsEnum.Update] }]} />} />
      <Route path={RouteParamsTypes.any} element={<Navigate replace to={{ pathname: Modules.error + NonAuthRoutes.notFound }} />} />
    </Routes>
  );
};

export default Invoices;
